module.exports = __webpack_public_path__ + "static/gunung-merapi-02fbcf626622fb494ad546b84471f4d8.png";